import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ["list", "input"];

  connect() {
    this.sortable = Sortable.create(this.listTarget, {
      animation: 150,
      handle: ".drag-handle",
      ghostClass: "opacity-50",
      onEnd: this.updateOrder.bind(this)
    });
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy();
    }
  }

  updateOrder() {
    const order = Array.from(this.listTarget.children).map(
      (item) => item.dataset.sectionKey
    );

    console.log("Section order updated:", order);

    // Update hidden input with new order
    if (this.hasInputTarget) {
      this.inputTarget.value = JSON.stringify(order);
      console.log("Hidden input value:", this.inputTarget.value);
    } else {
      console.error("No input target found!");
    }
  }
}
